import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import Message from '../../../../Chat/Message/Message';
import styles from '../../ChatModal.module.scss';
import Paragraph from '../../../../Typography/Paragraph/Paragraph';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
const ChatBox = React.forwardRef(({ group, messages, loadMore, hasMore, walletInfo }, ref) => {
    const { t } = useTranslation();
    const LoaderElement = useMemo(() => (_jsx("div", Object.assign({ className: cn('d-flex justify-content-center') }, { children: _jsx(Paragraph, { title: t('loading'), size: 4, color: 'grey', className: styles.loadMore }) }))), []);
    return (_jsx("div", Object.assign({ id: 'scrollable', className: styles.chat, ref: ref }, { children: _jsx(InfiniteScroll, Object.assign({ style: {
                display: 'flex',
                flexDirection: 'column-reverse',
                overflow: 'hidden',
                margin: `0.8rem 1.4rem`
            }, dataLength: messages.length, next: loadMore, inverse: true, hasMore: hasMore, loader: LoaderElement, scrollableTarget: 'scrollable' }, { children: messages.map((message, idx) => {
                var _a;
                return (_jsx("div", Object.assign({ className: styles.message }, { children: _jsx(Message, { nextDate: (_a = messages[idx + 1]) === null || _a === void 0 ? void 0 : _a.createdAt, name: group ? message.user.name : '', address: message.user.address, date: message.createdAt, message: message.message, my: message.user.address === (walletInfo === null || walletInfo === void 0 ? void 0 : walletInfo.stakeId) }) }), message.id));
            }) })) })));
});
export default ChatBox;
